import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './HomePage.module.scss';
import { memo, useEffect, useLayoutEffect, useMemo, useRef } from 'react';
import Message from './Message';
import { createNewDate, getDatefromDate } from '../../utils/utils';
import GetDateMessage from './GetDateMessage';
import { useAppDispatch, useAppSelector } from '../../hooks/hook';
import AdvancedContent from './AdvancedContent';
import { Virtuoso } from 'react-virtuoso';
import { setIsAtBottomScroll } from '../../store/slices/appSlice';
import { useChatMessages } from '../../hooks/useChatMessages';
import { ErrorConnectionComponent } from '../feedback/FeedbackComponets';
const VariableHeightList = ({ items, noRead, assignElementToScroll, }) => {
    const virtuosoRef = useRef(null);
    const dispatch = useAppDispatch();
    const searchIndexes = useAppSelector(state => state.app.targetMessages);
    const setAtBottomScroll = (isBottom) => {
        dispatch(setIsAtBottomScroll(isBottom));
    };
    const hasInitialScrolled = useRef(false);
    const currentChatId = useAppSelector(state => { var _a; return (_a = state.app.selectedChat) === null || _a === void 0 ? void 0 : _a.chatID; });
    const searchSet = useMemo(() => new Set(searchIndexes), [searchIndexes]);
    useLayoutEffect(() => {
        if (virtuosoRef.current && items.length > 0 && !hasInitialScrolled.current) {
            const timeoutId = setTimeout(() => {
                var _a;
                (_a = virtuosoRef.current) === null || _a === void 0 ? void 0 : _a.scrollToIndex({
                    index: noRead.targetIndex,
                    align: 'center',
                    behavior: 'auto'
                });
                hasInitialScrolled.current = true;
            }, 50);
            return () => clearTimeout(timeoutId);
        }
    }, [items.length, noRead.targetIndex]);
    useLayoutEffect(() => {
        hasInitialScrolled.current = false;
    }, [currentChatId]);
    useEffect(() => {
        assignElementToScroll(virtuosoRef.current);
        return () => assignElementToScroll(null);
    }, [assignElementToScroll]);
    const renderRow = (index, item) => {
        const isHighlighted = searchSet.has(index);
        const rowStyle = {
            borderRadius: '16px',
            backgroundColor: isHighlighted ? "#53525270" : "transparent",
            borderBottom: isHighlighted ? "2px solid #2368af7a" : "transparent",
            transition: "background-color 0.3s ease",
            padding: '2px 0'
        };
        const showDate = index === 0 ||
            (getDatefromDate(createNewDate(item.date)) !== getDatefromDate(createNewDate(items[index - 1].date)));
        return (_jsxs("div", { style: rowStyle, children: [showDate && _jsx(GetDateMessage, { date: item.date }), _jsx(Message, { messageInfo: item }, item.messageID)] }));
    };
    if (items.length < 1)
        return null;
    return (_jsx(Virtuoso, { initialTopMostItemIndex: noRead.targetIndex, ref: virtuosoRef, data: items, itemContent: renderRow, overscan: 800, 
        //increaseViewportBy={1000}
        //alignToBottom={true}
        atBottomStateChange: setAtBottomScroll, followOutput: (isAtBottom) => {
            if (isAtBottom)
                return 'smooth';
            return false;
        } }));
};
const ListMessages = () => {
    const list = useAppSelector(state => state.messages);
    const selectedChat = useAppSelector(state => state.app.selectedChat);
    const scrollElementRef = useRef(null);
    const assignElementToScroll = (element) => {
        scrollElementRef.current = element;
    };
    const { errorConnection } = useChatMessages(selectedChat);
    console.log('render list messages');
    if (errorConnection)
        return (_jsx(ErrorConnectionComponent, { errorConnection: errorConnection }));
    return (_jsxs("div", { className: styles.contentWrapper, children: [_jsx("div", { className: styles.listMessages, children: _jsx("div", { id: 'listForMessages', className: styles.listMessages_container, children: _jsx(VariableHeightList, { items: list.messages, noRead: list.noRead, assignElementToScroll: assignElementToScroll }) }) }), _jsx(AdvancedContent, { noRead: list.noRead, scrollElement: scrollElementRef })] }));
};
export default memo(ListMessages);
